import React from "react";

type MultiStepFormProps = {
  steps: { label: string }[];
  currentStep: number;
  setCurrentStep: (step: number) => void;
};

const MultiStepForm: React.FC<MultiStepFormProps> = ({
  steps,
  currentStep,
  setCurrentStep,
}) => {
  return (
    //changed this to only handle the steps at the top of the form
    <div className="multi-step-form">
      <div className="flex justify-center ">
        {steps.map((step, index) => (
          <button key={index} onClick={() => setCurrentStep(index)}>
            <div
              className={`mx-20 mb-2 p-2 p-2 rounded-full ${
                currentStep === index ? "bg-deepGreen-500 " : "bg-grayScale-300"
              }`}
            ></div>
            {step.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MultiStepForm;
